import * as React from 'react'
import * as NotFoundTemplate from '../templates/NotFound'

export const Component = () => {
    return <NotFoundTemplate.Component />
}
